// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Enviada: 0,
    EmAnalise: 1,
    Negada: 2,
    Aprovada: 3,
    Revogada: 4,
    AlteracaoPasta: 5
}